const TokenKey = 'Token'
const UserInfoKey = 'UserInfo'
const MemberKey = 'Member'

export function getToken() {
  return localStorage.getItem(TokenKey)
}
export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}
export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getUserInfo() {
  try{
    return JSON.parse(localStorage.getItem(UserInfoKey))
  }catch(err){
    return null
  }
}
export function setUserInfo(UserInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(UserInfo))
}
export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}

export function getMember() {
  return localStorage.getItem(MemberKey)
}
export function setMember(Member) {
  return localStorage.setItem(MemberKey, Member)
}
export function removeMember() {
  return localStorage.removeItem(MemberKey)
}

